var orientation;
var parent;
var initBreakdownChart= function(strType) {
  var stackedBarChartElement;
  if(parent) {
    stackedBarChartElement = parent.querySelector('.js-chartjs-stacked-bar');
  } else {
    stackedBarChartElement = document.querySelector('.js-chartjs-stacked-bar');
  }
  if (!stackedBarChartElement)
    return;

  if (stackedBarChartElement.chartJS)
    stackedBarChartElement.chartJS.destroy();

  var unsortedArr = JSON.parse($('#course_grade_breakdown_json').val() || '[]');
  var datasetsArr = _.sortBy(unsortedArr, function(obj){return obj.data[0];}).reverse();

  var scalesObj = {};
  if (strType == 'bar') {
    scalesObj = {
      yAxes: [{
        stacked: true,
        ticks: {
          stepSize: 20,
          beginAtZero: true
        }
      }],
      xAxes: [{
        display: false,
        stacked: true
      }]
    };
  } else {
    scalesObj = {
      yAxes: [{
        stacked: true,
        display: false
      }],
      xAxes: [{
        stacked: true,
        ticks: {
          stepSize: 20,
          beginAtZero: true
        }
      }]
    };
  }

  var stackedBar = new Chart(stackedBarChartElement, {
    type: strType,
    data: {
      labels: [],
      datasets: datasetsArr
    },
    options: {
      maintainAspectRatio: false,
      scales: scalesObj,
      legend: {
        position: 'right',
        labels: {
          boxWidth: 15,
          reverse: false
        }
      },
      tooltips: {
        titleSpacing: 0,
        xPadding: 15,
        callbacks: {
          label: function(tooltipItem, data){
            var axisLabel;
            if (orientation === 'vertical'){
              axisLabel = tooltipItem.yLabel;
            }else{
              axisLabel = tooltipItem.xLabel;
            }
            return data.datasets[tooltipItem.datasetIndex].label + ': ' + axisLabel + '%';
          }
        }
      }
    }
  });
  stackedBarChartElement.chartJS = stackedBar;
};

export default {
  init: function(type, parentEle) {
    var strType = (type == 'horizontal') ? 'horizontalBar' : 'bar';
    orientation = type;
    parent = parentEle;
    console.log('GradeBreakdownChart initialization called');
    initBreakdownChart(strType);
  }
};
